/**
 * Image Preloader Utility
 * Preloads critical images for better perceived performance
 */

// Preload a single image
export function preloadImage(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = reject;
    img.src = src;
  });
}

// Preload multiple images
export function preloadImages(srcs: string[]): Promise<void[]> {
  return Promise.all(srcs.map(preloadImage));
}

// Preload hero image with link preload hint
export function preloadHeroImage(src: string): void {
  if (!src) return;
  
  // Use link preload for critical hero images
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'image';
  link.href = src;
  document.head.appendChild(link);
}

// Generate responsive image srcset
export function generateSrcSet(baseUrl: string, sizes: number[]): string {
  return sizes
    .map(size => `${baseUrl}?width=${size} ${size}w`)
    .join(', ');
}

// Get optimal image size based on viewport
export function getOptimalImageSize(): number {
  const width = window.innerWidth;
  if (width <= 640) return 640;
  if (width <= 768) return 768;
  if (width <= 1024) return 1024;
  if (width <= 1280) return 1280;
  return 1920;
}
